import omitBy from 'lodash.omitby'

import { parseAndFormatQuery } from 'src/routing'

type Query = {
  page?: number
  perPage?: number
}

export const getQuery = (query: string): Query => {
  const parsed = parseAndFormatQuery<Query>(query, {
    page: {
      type: 'number',
    },
    perPage: {
      type: 'number',
    },
  })

  return omitBy(parsed, (v) => v === undefined)
}

export const getNumPages = (perPage: number, totalCount: number = 0) =>
  Math.ceil(totalCount / perPage)
